module.exports = __webpack_public_path__ + "img/card1_img_2.96ce0102.jpg";